/*
  Journey waypoint lightboxes (Watercolor Atlas).
  - [data-dw-waypoint="<dialog-id>"] buttons open their <dialog> via showModal().
  - [data-dw-dialog-close] buttons close the containing dialog.
  - Clicking the backdrop closes the dialog; Escape closes it natively, with a
    keydown fallback for browsers without <dialog> method support.
  - Focus returns to the waypoint button that opened the dialog on every close
    path (close button, backdrop, Escape).
  - Falls back to the [open] attribute when <dialog>.showModal is unsupported.
  - Idempotent: safe to include the script tag more than once per page.
*/
(function () {
  'use strict';

  if (window.__dwJourneyInit) return;
  window.__dwJourneyInit = true;

  function restoreFocus(dialog) {
    var opener = dialog.__dwReturnFocus;
    dialog.__dwReturnFocus = null;
    if (opener && typeof opener.focus === 'function' && document.contains(opener)) {
      opener.focus();
    }
  }

  function closeDialog(dialog) {
    dialog.__dwFallbackOpen = false;
    if (typeof dialog.close === 'function') {
      dialog.close(); /* fires the 'close' event, which restores focus */
    } else {
      dialog.removeAttribute('open');
      restoreFocus(dialog);
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var opener = event.target.closest('[data-dw-waypoint]');
    if (opener) {
      event.preventDefault();
      var dialog = document.getElementById(opener.getAttribute('data-dw-waypoint'));
      if (!dialog) return;
      dialog.__dwReturnFocus = opener;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        dialog.__dwFallbackOpen = true;
        /* showModal moves focus into the dialog natively; mirror that here. */
        var closeBtn = dialog.querySelector('[data-dw-dialog-close]');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      }
      return;
    }

    var closer = event.target.closest('[data-dw-dialog-close]');
    if (closer) {
      var parentDialog = closer.closest('dialog');
      if (parentDialog) closeDialog(parentDialog);
      return;
    }

    /* Backdrop click: a modal <dialog> stretches to the viewport, so hit-testing
       the dialog's own rect never reports "outside". Close when the click lands
       on the dialog element itself (its padding/backdrop area) rather than on
       any child content, and cross-check against the first element child's box
       for browsers that report the dialog box as the content box. */
    var openDialog = document.querySelector('dialog.dw-waypoint-dialog[open]');
    if (openDialog) {
      var onDialogSurface = event.target === openDialog;
      var outsidePanel = false;
      if (!onDialogSurface && openDialog.contains(event.target) === false) {
        outsidePanel = true;
      }
      if (onDialogSurface) {
        var panel = openDialog.querySelector('.dw-waypoint-dialog__body, .dw-waypoint-dialog__content, .dw-waypoint-dialog__media');
        var box = panel ? panel.getBoundingClientRect() : openDialog.getBoundingClientRect();
        var insidePanel =
          event.clientX >= box.left &&
          event.clientX <= box.right &&
          event.clientY >= box.top &&
          event.clientY <= box.bottom;
        if (!insidePanel) outsidePanel = true;
      }
      if (outsidePanel) closeDialog(openDialog);
    }
  });

  /* Native closes (Escape key, dialog.close()) — return focus to the opener.
     'close' does not bubble, so listen in the capture phase. */
  document.addEventListener(
    'close',
    function (event) {
      var dialog = event.target;
      if (dialog && dialog.classList && dialog.classList.contains('dw-waypoint-dialog')) {
        restoreFocus(dialog);
      }
    },
    true
  );

  /* Escape fallback for dialogs opened via the [open] attribute (no showModal). */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var open = document.querySelector('dialog.dw-waypoint-dialog[open]');
    if (open && open.__dwFallbackOpen) closeDialog(open);
  });
})();
